// extracted by mini-css-extract-plugin
export var avatarContainer = "_gq-0";
export var avatarTypingWave = "_gq-i";
export var gray = "_gq-f";
export var green = "_gq-c";
export var icon = "_gq-9";
export var image = "_gq-1";
export var lg = "_gq-6";
export var md = "_gq-5";
export var presenceDot = "_gq-b";
export var red = "_gq-d";
export var sm = "_gq-4";
export var status = "_gq-a";
export var typingDot = "_gq-h";
export var typingPill = "_gq-g";
export var xl = "_gq-7";
export var xs = "_gq-3";
export var xxl = "_gq-8";
export var xxs = "_gq-2";
export var yellow = "_gq-e";